import { render, staticRenderFns } from "./tipEdit.vue?vue&type=template&id=45fdd93a&scoped=true&"
import script from "./tipEdit.vue?vue&type=script&lang=js&"
export * from "./tipEdit.vue?vue&type=script&lang=js&"
import style0 from "./tipEdit.vue?vue&type=style&index=0&id=45fdd93a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fdd93a",
  null
  
)

export default component.exports